import { addOrderItem, clearAddItemError, fetchAMPs } from '../../../redux/modules/neworder';
import { loggedIn } from '../../../routes/conditional';
import { chainAPIActions } from '../../../redux/middleware/chain';
import paths from '../../../routes/paths';
import { getNewOrderMedicineFormItem } from '../../../redux/modules/root-reducer';

export const page = {
  path: paths.createOrder.selectMedicineStrength,
  isAllowed: [loggedIn],
  action: ({ state }) => chainAPIActions(fetchAMPs(getNewOrderMedicineFormItem(state))),
};

export const addMedicine = {
  actionPath: '/actions/add-medicine',
  inputName: 'medicine',
  mapMedicineToInputValue: m => JSON.stringify(m),
  action: req => {
    let medicine = null;
    try {
      medicine = JSON.parse(req.body.medicine);
    } catch (e) {
      // none
    }
    return addOrderItem(medicine);
  },
};

export const clearSelectionError = {
  actionPath: '/actions/clear-selection-error',
  action: () => clearAddItemError(),
};